import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';

import { API_URL, enrichedFetch } from '../../services/api';
import { User } from '../../Types/user';
import { RootState } from '../store';

export const getUsers = createAsyncThunk<User[], { ids: string[] }, { state: RootState }>(
  'users/fetchUsers',
  async ({ ids }, { getState, rejectWithValue }) => {
    const { searchQuery } = getState().users;

    try {
      let url = `${API_URL}/user`;
      if (searchQuery.trim().length > 0) {
        url += `?search=${searchQuery}`;
      }
      ids.forEach((id) => url + `&ids=${id}`);

      const response = (await enrichedFetch(url)) as User[];
      return response;
    } catch {
      enqueueSnackbar('Failed to fetch folders', { variant: 'error' });
      return rejectWithValue('Failed to fetch folders');
    }
  }
);
